import type { ReactNode } from "react";
import { I18nContext, useTranslation } from "react-i18next";

/**
 * `<Trans>` reads the i18n context but doesn't listen to language changes, so
 * elements created once (module-level constants like the start guide steps)
 * kept the old language. A new context value on every language change makes
 * React re-render every `<Trans>` below, wherever it was created.
 */
export function I18nLanguageProvider({ children }: { children: ReactNode }) {
  // re-renders on languageChanged; nothing else re-renders this component
  const { i18n } = useTranslation();
  return <I18nContext value={{ i18n }}>{children}</I18nContext>;
}
